import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { Alert, Flex, Form } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import TextArea from 'antd/es/input/TextArea'
import { FC } from 'react'

interface Props {}

const BookingConnectorIntercomSection: FC<Props> = ({}) => {
  const venue = useAppSelector(selectSelectedVenue())
  const formItemNameBase: NamePath = [
    'booking',
    'app',
    'connectors',
    'intercom',
  ]

  if (!venue) return <></>

  return (
    <Flex vertical style={{ padding: 20 }} gap={16}>
      <Alert title="When the user clicks the Book button on the page, an Intercom modal will open with a new conversation. You can choose a message to pre-fill the user's text field. The user can still edit this message before sending it." />
      <Form.Item
        name={[...formItemNameBase, 'message']}
        label={'Pre-filled message'}
        rules={[]}
      >
        <TextArea
          showCount
          maxLength={250}
          placeholder={`I want to book at ${venue.name} ...`}
        />
      </Form.Item>
    </Flex>
  )
}

export { BookingConnectorIntercomSection }
